﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class PluginClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    getAllPlugins() {
        return this.client.apiPluginsGet();
    }
    getPlugin(pluginName) {
        return this.client.apiPluginsByIdGet(pluginName);
    }
    unblockPlugin(pluginName) {
        return this.client.apiPluginsUnblockPost(pluginName);
    }
    uninstallPlugin(pluginName) {
        return this.client.apiPluginsUninstallDelete(pluginName);
    }
}
exports.PluginClient = PluginClient;
//# sourceMappingURL=PluginClient.js.map